<template>
  <div>
    <b-table
      head-variant="light"
      :empty-text="$t('GERAL.NENHUM_REGISTRO')"
      :items="itens"
      :fields="campos"
      responsive
      show-empty
      stacked="md"
      striped
      hover
      no-local-sorting
      @sort-changed="aoMudarOrdenacao"
    >
      <template #cell(acoes)="item">
        <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
          <b-dropdown-item @click="visualizar(item.item)" v-if="podeVisualizar">
            {{ $t('GERAL.VISUALIZAR') }}
          </b-dropdown-item>
          <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
            {{ $t('GERAL.EDITAR') }}
          </b-dropdown-item>
          <!-- <b-dropdown-item @click="excluir(item.item)">
            {{ $t('GERAL.EXCLUIR') }}
          </b-dropdown-item> -->
        </b-dropdown>
      </template>
    </b-table>
  </div>
</template>

<script>
// AUX & HELPES
import rotas from '@/common/utils/rotas';
import helpers from '@/common/utils/helpers';
import Permissoes from '@/components/mixins/permissoes';

export default {
  mixins: [Permissoes],
  name: 'TabelaDocumentosPadrao',
  components: {},
  props: {
    itens: { type: Array, default: Array },
  },
  data() {
    return {
      campos: [
        {
          key: 'codigo',
          label: this.$t('ACADEMICO.CODIGO'),
          sortable: true,
        },
        {
          key: 'nome',
          label: this.$t('GERAL.NOME'),
          formatter: (value) => {
            return value ? value : '-';
          },
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
    };
  },
  methods: {
    visualizar(item) {
      this.$emit('visualizar', item);
    },
    editar(item) {
      rotas.irPara(
        'academico-estrutura-cej-formulario-documento-padrao',
        item.id
      );
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
